// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-group-container {\n  font-size: 10px;\n}\n.card-group-container .card-group {\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n}\n.card-group-container .card-group-icon {\n  height: 25px;\n  width: 20px;\n}", ""]);
// Exports
module.exports = exports;
